export default __webpack_public_path__ + "static/media/Success-Gif.261964f5.gif";